import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { BulkExtractResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetBulkExtract = (
  pageTable: number,
  resultsPerPage: number = 20
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, BulkExtractResponse>(
    ["bulkExecs", "all", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage
      };

      const data = await axiosClient.get<BulkExtractResponse>(
        `/execution/bulkExtract/getAll?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      refetchInterval: 5000
    }
  );
};
